import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAccountStore } from '@/stores/account';
import { useProgramsStore } from '@/stores/programs';
import { watch } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Empty',
  setup(__props) {

const accountStore = useAccountStore()
const programsStore = useProgramsStore()
const router = useRouter()
watch(() => programsStore.programs[0], value => {
  if (value) {
    if (accountStore.isDirector) {
      router.push({ name: "analitics", params: { programId: value.id } })
    } else {
      const team = programsStore.programs[0].teams[0]?.id || undefined
      router.push({ name: "reports", params: { programId: value.id } })
    }
  }
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Loading..."))
}
}

})